import type { ChangelogEntry } from "../types";

/**
 * Faktura-siden viste importdatoen i stedet for fakturadatoen, manglet etikett
 * for kreditnota og viste sendte fakturaer som «Sendt» etter forfall. Siden har
 * nå oppsummeringskort, flere kolonner, filtre i adressen og paginering.
 */
export const FAKTURAOVERSIKT_2026_10: ChangelogEntry = {
  id: "2026-10-26-fakturaoversikt",
  date: "2026-10-26",
  title: "Faktura-siden viser riktig dato og status, og har oppsummering øverst",
  summary:
    "Fakturadatoen erstatter importdatoen, kreditnota og forfalte fakturaer vises tydelig, og kortene øverst viser utestående, forfalt og fakturert i år.",
  sections: [
    {
      heading: "Fakturering",
      minRole: "user",
      items: [
        {
          title: "Kort for utestående, forfalt, fakturert i år og ikke sendt",
          kind: "nytt",
          body: "Øverst på Faktura-siden står det hva kundene skylder, hvor mye som har forfalt, hva som er fakturert i år og hvor mange utkast som ikke ble sendt. Klikk på et kort for å filtrere lista.",
        },
        {
          title: "Fakturanummer, forfall og sortering på prosjekt og kunde",
          kind: "nytt",
          body: "Lista har kolonner for fakturanummer og forfallsdato, og kan sorteres på fakturadato, prosjekt, kunde, beløp og forfall. Søket treffer også fakturanummer og prosjektnavn.",
        },
        {
          title: "Periode, flere typer og filtre du kan dele",
          kind: "nytt",
          body: "Velg i år, i fjor, siste 12 måneder, alle eller egne datoer. Typefilteret har fått Kreditnota og Fra PowerOffice. Filtrene står i adressen, så en lenke viser det samme for den du sender den til. Lista viser 50 fakturaer om gangen.",
        },
        {
          title: "Datoen er fakturadatoen, ikke importdatoen",
          kind: "rettet",
          body: "De fleste fakturaene viste 09.04.2026, som var dagen de ble importert fra PowerOffice. Nå vises fakturadatoen. Noen eldre fakturaer mangler den fra PowerOffice og vises med en strek.",
        },
        {
          title: "Kreditnota og forfalte fakturaer vises riktig",
          kind: "rettet",
          body: "Kreditnotaer viste en teknisk kode i statusfeltet. Nå står det Kreditnota med negativt beløp. En sendt faktura med passert forfallsdato vises som Forfalt med antall dager, og et utkast som ikke ble sendt viser årsaken.",
        },
      ],
    },
  ],
};
